module.exports = __webpack_public_path__ + "16d4d38fcf14a66800f123ae987ca1ae.ttf";